import { Controller } from "stimulus";
import Cookies from 'js-cookie';
export default class extends Controller {

  showSelected(evt) {
      evt.stopPropagation()
      let selectedHref = evt.target.dataset.href;
      if (selectedHref) {
        Cookies.set('toggleToResults', {searchHref: window.location.href, resultsCount: $('.totalCount').first().text()})
        window.location.href = selectedHref
      }
  }

  showResults(evt) {
    evt.stopPropagation()
    let resultsHref = evt.target.dataset.href;
    if (resultsHref) {
      window.location.href = resultsHref
    }
  }

}